import React from 'react'

import AttachmentButtonDownload from "../../../../files/attachment-view/blocks/buttons/download"
import AttachmentButtonOpenNewWindow from "../../../../files/attachment-view/blocks/buttons/open-new-window"

export enum AlignType {
    LEFT    = 'left',
    CENTER  = 'center',
    RIGHT   = 'right'
}

type Props = {
    alignment           : AlignType
    attachment?         : any

    onChangeAlignment   : {(id: AlignType):void}
    onRemove            : {():void}

    className?          : string
}

export default class AlignSelector extends React.Component<Props> {

    onChangeAlignment = (id: AlignType) => {
        if (this.props.onChangeAlignment) this.props.onChangeAlignment(id)
    }

    renderItem(item: any) {
        const classes = Classes("option-tab", {
            selected: item.id === this.props.alignment
        })
        return (
            <div key={item.id} className={classes} onClick={!!item.onClick ? item.onClick : this.onChangeAlignment.bind(this,item.id)}>
                <div className={item.icon}/>
            </div>
        )
    }

    onDeleteClick = () => {
        // console.log(".onDeleteClick()")

        // remove from message
        this.props.onRemove()

        // then delete
        this.props.attachment?.refAttachmentManager.current.onRemove(this.props.attachment)
    }

    render() {
        const autoDistributionOptions = [
            {id: AlignType.LEFT,    icon: 'option-icon i5-allign-image-left'},
            {id: AlignType.CENTER,  icon: 'option-icon i5-allign-image-center'},
            {id: AlignType.RIGHT,   icon: 'option-icon i5-allign-image-right'}
        ]

        // console.log("ALIGNMENR attachemnt-=", this.props.attachment)
        // console.log("    render mode =", this.props.attachment.renderMode)
        // console.log("    isSaved =", this.props.attachment.isSaved)

        const {attachment} = this.props

        let renderMode = attachment ? this.props.attachment.renderMode : null

        switch (renderMode) {
            case 'notes-edit':
                return (
                    <div className={Classes("align-selector", this.props.className)}>
                        <div className="align-options">
                            {autoDistributionOptions.map(item=>this.renderItem(item))}
                        </div>

                        {attachment?.isSaved && <AttachmentButtonDownload attachment={this.props.attachment} className="m-l-10 m-r-8"/>}
                        {attachment?.isSaved && <AttachmentButtonOpenNewWindow attachment={this.props.attachment} className="m-r-8"/> }
                        <div className="ui5-ico-round red i5-trash-alt m-r-10" onClick={this.onDeleteClick} />
                    </div>
                )

            default:
                return (
                    <div className={Classes("align-selector", this.props.className)}>
                        <div className="align-options">
                            {autoDistributionOptions.map(item=>this.renderItem(item))}
                        </div>

                        <div className="option-tab remove-option" onClick={this.props.onRemove}>
                            <div className="ui5-ico-round red size-18 i5-delete"/>
                        </div>
                    </div>
                )
        }
    }
}